import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseProductTaste } from "./UseProductTaste";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function AddProductTaste(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [taste, setTaste] = useState();
  const { validate, addTaste } = UseProductTaste();
  const { goToLastPage } = UseProductTaste();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    name: undefined,
    codeName: undefined,
  });

  const [errorState, setErrorState] = useState({
    name: false,
  });
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/producttaste" },
          { name: "طعم جدید", url: "/producttaste/addproducttaste" },
        ],
      }}
    >
      {!taste ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              sx={{ width: "100%" }}
              value={state.name ? state.name : ""}
              error={errorState.name}
              label="نام "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, name: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              value={state.codeName ? state.codeName : ""}
              error={errorState.codeName}
              sx={{
                width: "100%",
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, codeName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addTaste(state, () => {
                    navigate("/producttaste", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/producttaste", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default AddProductTaste;
